import * as React from 'react';
import { NativeAdObj } from '../../../shared/types/ast';

type Props = {
    adObj: NativeAdObj;
    className?: string;
    style?: React.CSSProperties;
    dangerouslySetInnerHTML?: { __html: string };
    children: React.ReactNode;
    overrideClassName?: string;
};

function getClassName(className?: string) {
    return `${
        className ? `${className} ` : ''
    } linkblock dark-links clickable link link--dark `;
}

// TODO: Check if we can use noreferrer on the links
/* eslint-disable react/jsx-no-target-blank */
const Link = React.forwardRef(function Button(
    {
        adObj: { native },
        className,
        overrideClassName,
        style,
        dangerouslySetInnerHTML,
        children,
    }: Props,
    ref: React.Ref<HTMLAnchorElement>,
) {
    return (
        <a
            ref={ref}
            href={native.clickUrl}
            className={overrideClassName || getClassName(className)}
            style={style}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            target="_blank"
            rel="noopener"
        >
            {children}
        </a>
    );
});
/* eslint-enable react/jsx-no-target-blank */

export default Link;
